import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { app } from './client';

export const functions = getFunctions(app);

if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)) {
  connectFunctionsEmulator(functions, window.location.hostname, 5001);
}
